// RoleGuard.tsx

import { Navigate, Outlet } from "react-router-dom";
import { PRIVATE_ROUTES } from "../shared/general.constants";

interface RoleGuardProps {
  roles: string[];
  roleCondition: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ roles, roleCondition }) => {
  if (roles.length === 0) {
    return <div>Cargando</div>;
  }
  if (roleCondition === "g-co-ventaneros-todos") {
    const hasAccess =
      roles.some((item) => item.startsWith("g-co-ventaneros-todos")) ||
      roles.includes("g-automation-admin");

    return hasAccess ? (
      <Outlet />
    ) : (
      <Navigate replace to={PRIVATE_ROUTES.PRIVATE} />
    );
  }
};

export default RoleGuard;
